import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';
import getArticles from './getArticles';

export const clearPostArticlesData = createAction('articles/clearPostArticlesData');

const postArticles = createAsyncThunk('articles/postArticles',
  async (formData = {}, { rejectWithValue, dispatch }) => {
    try {
      const data = await authSet(METHOD_POST, '/articles/create', formData);
      dispatch(getArticles());
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postArticles;
